<template>
    <panel-navigation>
        <div class="p-6 bg-slate-50 min-h-screen">
            <!-- Header & Controls -->
            <div class="flex flex-wrap justify-between items-center mb-6 gap-4">
            <div>
                <h1 class="text-2xl font-bold text-slate-800">Public Report Engagement</h1>
                <p class="text-xs text-slate-500">Track client and visitor activity on public dashboard links.</p>
            </div>

            <!-- Filters -->
            <div class="flex items-center gap-3">
                <!-- Client Filter -->
                <v-select
                outlined dense hide-details
                label="Filter by Client"
                class="bg-white rounded w-60"
                :items="clientOptions"
                item-text="company_name"
                item-value="id"
                v-model="filters.user_id"
                @change="fetchStats"
                ></v-select>

                <!-- Date Range Selectors -->
                <v-text-field
                type="date"
                outlined dense hide-details
                v-model="filters.start_date"
                @change="fetchStats"
                class="bg-white rounded w-36"
                ></v-text-field>
                <span class="text-slate-400">-</span>
                <v-text-field
                type="date"
                outlined dense hide-details
                v-model="filters.end_date"
                @change="fetchStats"
                class="bg-white rounded w-36"
                ></v-text-field>
            </div>
            </div>

            <!-- Summary KPI Cards -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
                <div class="text-xs font-bold uppercase text-slate-400">Total Report Openings</div>
                <div class="text-3xl font-extrabold text-slate-800 mt-1">{{ stats.total_views }}</div>
            </div>
            <div class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
                <div class="text-xs font-bold uppercase text-slate-400">Average Openings / Day</div>
                <div class="text-3xl font-extrabold text-indigo-600 mt-1">{{ stats.avg_per_day }}</div>
            </div>
            <div class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
                <div class="text-xs font-bold uppercase text-slate-400">Unique IP Visitors</div>
                <div class="text-3xl font-extrabold text-emerald-600 mt-1">{{ stats.unique_ips }}</div>
            </div>
            </div>

            <!-- Latest Openings Table -->
            <div class="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
            <h3 class="font-bold text-slate-800 text-sm mb-4">Latest Report Openings</h3>
            
            <v-data-table
                :headers="headers"
                :items="stats.latest_logs"
                :loading="loading"
                dense
                hide-default-footer
                class="elevation-0"
            >
                <template v-slot:item.user="{ item }">
                <strong>{{ item.user ? item.user.company_name : 'Unknown Client' }}</strong>
                </template>

                <template v-slot:item.created_at="{ item }">
                {{ formatDate(item.created_at) }}
                </template>

                <template v-slot:item.device_type="{ item }">
                <span class="px-2 py-0.5 text-xs rounded bg-slate-100 text-slate-700 font-semibold">
                    {{ item.device_type }} ({{ item.browser }})
                </span>
                </template>
            </v-data-table>
            </div>
        </div>

    </panel-navigation>
</template>

<script>

import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  name: 'ReportViewsStats',
  components: {
    PanelNavigation
  },
  data() {
    return {
      loading: false,
      filters: {
        user_id: 'all',
        start_date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
        end_date: new Date().toISOString().substr(0, 10)
      },
      stats: {
        total_views: 0,
        avg_per_day: 0,
        unique_ips: 0,
        latest_logs: []
      },
      headers: [
        { text: 'Client / Business', value: 'user' },
        { text: 'Opened At', value: 'created_at' },
        { text: 'IP Address', value: 'ip_address' },
        { text: 'Device & Browser', value: 'device_type' }
      ]
    };
  },
  computed: {
    ...mapState({
      businesses: state => state.businesses.businesses,
      fetchingBusinesses: state => state.businesses.fetchingBusinesses,
      me: state => state.me.me,
      profile: state => state.me.profile
    }),
    clientOptions() {
      const list = [{ id: 'all', company_name: 'All Clients' }];
      if (this.businesses && Array.isArray(this.businesses)) {
        return list.concat(this.businesses);
      }
      return list;
    }
  },
  mounted() {
    this.fetchStats();
  },
  methods: {
    async fetchStats() {
      this.$store.state.businesses.fetchingBusinesses = true
      this.$store.dispatch('businesses/fetch')

      this.loading = true;
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/public-report-stats`, { params: this.filters }, {
            headers: { 'Authorization': 'Bearer ' + this.$store.state.auth.jwt }
        });
        this.stats = response.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleString();
    }
  }
};
</script>